import { ContentType } from '@creditsights/api-ui-web';

export const isHeaderFooterVisible = (contentType?: ContentType): boolean => contentType === ContentType.Research;
